import { ColorsNeutral50, ColorsNeutral900, ColorsWhite } from '@fff-web/design-tokens/colors';
import type { GigaWidgetConfig } from './types';

export const GIGA_SCRIPT_ID = '__giga-chatbot-script';

/** Id of the widget root the Giga loader appends to `<body>`; teardown removes it directly. */
export const GIGA_WIDGET_ROOT_ID = 'gigaml-container';

/** Giga's self-injecting widget loader. Reads `window.CHAT_WIDGET_CONFIG`, set before it loads. */
export const GIGA_SCRIPT_SRC = 'https://widget.gigaml.com/inject-gigaml.js';

/** Global config object the loader reads to build the widget. */
export const GIGA_CONFIG_GLOBAL = 'CHAT_WIDGET_CONFIG';

/**
 * Static FFF branding for the Giga widget. Giga's schema requires the colors, tagline and icon at
 * runtime — single source of truth, edit here. Colors are the FFF brand palette from
 * `@fff-web/design-tokens`.
 *
 * TODO(WEB-6376): confirm the final colors and tagline with design.
 */
export const GIGA_BRANDING: Partial<GigaWidgetConfig> = {
  company_name: 'FabFitFun',
  position: 'bottom-right',
  primary_color: ColorsNeutral900,
  primary_text_color: ColorsWhite,
  secondary_color: ColorsNeutral50,
  secondary_text_color: ColorsNeutral900,
  tagline: 'How can we help?',
  // Square FFF logo, hosted on Sanity's CDN.
  icon_url:
    'https://cdn.sanity.io/images/q4cs1xgp/production/e995aa6800f7b66394ed140f82f04005efb643f2-201x200.png',
};
